import { AfterViewChecked, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-h-tab-bar',
  templateUrl: './h-tab-bar.component.html',
  styleUrls: ['./h-tab-bar.component.scss']
})
export class HTabBarComponent implements OnInit, AfterViewChecked {

  @ViewChild('activeTabBg') activeTabBg: ElementRef;
  @Output() onSelectTab = new EventEmitter<any>();
  @Input() type: "account" | "loan" | "deposit" | "debit" = "account";
  @Input () tabContentVisiblity:boolean = true;
  @Input() set tabs(data: any) {
    if(data) this.refreshData(data);
  }
  
  get tabs(): any {
    return this._tabList;
  }
  
  tabPadding:number = 0;
  activeTab: any;
  _tabList:any = [];

  private redrawUnderline: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  @HostListener('window:resize', ['$event'])
	onResize(event) {
		this.positionUnderline();
	}
  
  selectTab(id){
    this.activeTab = id;
    this.redrawUnderline = true;
    this.onSelectTab.emit(id);
  }

  positionUnderline(){
    let tab = document.getElementById("tab_" + this.type + "_" + this.activeTab);
    if(tab){
      this.activeTabBg.nativeElement.style.left = (tab.offsetLeft - this.tabPadding) + 'px';
      this.activeTabBg.nativeElement.style.width = (tab.offsetWidth + this.tabPadding*2) + 'px';
    }
  }

  ngAfterViewChecked(): void {
      if(this.redrawUnderline){
        this.redrawUnderline = false;
        this.positionUnderline();
      }
  }

  refreshData(data:any){
    var _this = this;
    this._tabList = data;
    setTimeout(function(){
      if(_this._tabList.length){
        let id = 'overview';
        if(sessionStorage.getItem('selectTab') && sessionStorage.getItem('selectTab') == 'details'){
          id = 'details';
          sessionStorage.removeItem('selectTab');
        }else{
          id = _this._tabList[0].id;
        }
        _this.selectTab(id);
      }
    });
  }

  updateTab(tabId){
    this.selectTab(tabId);
  }
}
